import { M8CompanySize } from 'services/production/types';
import { OrgStaffCount } from 'types/orgInfoTypes';
import { UnreachableError } from 'utils/errors';

export const normalizeM8CompanySize = (m8CompanySize: M8CompanySize) => ({
  toOrgStaffCount(): OrgStaffCount | null {
    switch (m8CompanySize) {
      case 'LARGE':
        return 'large';
      case 'MIDDLE':
        return 'medium';
      case 'TINY':
        return 'small';
      case 'UNDEFINED':
        return null;
      default:
        throw new UnreachableError(m8CompanySize);
    }
  },
});
